import gql from 'graphql-tag';

export default gql(`{
  Me {
    uuid
    firstname
    lastname
    balance
    avatar
    comment
    address {
      zipcode
      city
    }
    given {
      uuid
      duration
    }
    received {
      uuid
      duration
    }
    supplies {
      uuid
      name
    }
    demands {
      uuid
      name
    }
  }
}`);



// WEBPACK FOOTER //
// ./src/api/query/Me.js